import { isObject, isArray, isBoolean, isEmptyArray, isEmptyObj } from './index';
import dayjs from 'dayjs'
import download from 'downloadjs'

// 通过JSON深拷贝
export const deepCloneByJSON = (data: any) => {
  if (Array.isArray(data) || isObject(data)) {
    return JSON.parse(JSON.stringify(data))
  } else {
    return data
  }
}

export const clearData = (data: any) => {
  if (isObject(data)) {
    for (let key in data) {
      if (isObject(data[key])) {
        clearData(data[key])
      } else if (isArray(data[key])) {
        data[key] = []
      } else if (isBoolean(data[key])) {
        data[key] = false
      } else {
        data[key] = ''
      }
    }
  }
}

/**
 * 将对象数组转为键值对对象
 * @param {Array[Object]} arr 原对象数组
 * @param {String} key             对象的key
 * @param {String} value           对象的value
 * @returns {Object}
 */
export const arrToObj = (arr = [], labelKey = 'label', valueKey = 'value') => {
  if (isEmptyArray(arr)) return {}
  return arr.reduce((p, c) => {
    p[c[labelKey]] = c[valueKey]
    return p
  }, {})
}


/**
 * 将对象转为键值对对象数组
 */
export const objToArr = (obj: DefaultObjectType, labelKey = 'label', valueKey = 'value') => {
  if (isEmptyObj(obj)) return []
  return Object.keys(obj).map(key => {
    return {
      [labelKey]: key,
      [valueKey]: obj[key]
    }
  })
}


export const Storage = {
  // 设置缓存
  sessionSet: function (name, data) {
    sessionStorage.removeItem(name)
    sessionStorage.setItem(name, JSON.stringify(data))
  },
  // 获取缓存
  sessionGet: function (name) {
    return JSON.parse(sessionStorage.getItem(name))
  },
  // 清除缓存
  sessionRemove: function (name) {
    sessionStorage.removeItem(name)
  },
  // ==================localStorage设置缓存==================
  // 设置缓存
  localSet: function (name, data) {
    localStorage.removeItem(name)
    localStorage.setItem(name, JSON.stringify(data))
  },
  // 获取缓存
  localGet: function (name) {
    return JSON.parse(localStorage.getItem(name))
  },
  // 清除缓存
  localRemove: function (name) {
    localStorage.removeItem(name)
  },
}

/**
 * 获取特定字段的数组
 * @param {Array[Object]} data  原对象数组
 * @param {String} key          对象的key
 * @returns {Array}
 */
export const getArrByReduce = (data, key) => {
  return !isEmptyArray(data)
    ? data.reduce((p, c) => {
      (!isEmptyObj(c)) && p.push(c[key])
      return p
    }, [])
    : []
}


/**
 * 对象数组去重
 * @param {*} arr   数组
 * @param {*} id    对象中唯一的id值
 * @returns
 */
export const unique = (arr, id) => {
  let object = {}
  let copyArr = arr.reduce((item, next) => {
    object[next[id]] ? '' : (object[next[id]] = true && item.push(next))
    return item
  }, [])
  return copyArr
}


// 节流函数
export const throttle = (handler, wait) => {
  let lastTime = 0
  return function (e) {
    let nowTime = new Date().getTime()
    if (nowTime - lastTime > wait) {
      handler.apply(this, arguments)
      lastTime = nowTime
    }
  }
}

export const getItemByProp = (resource, prop) => resource.flat().find(item => item.prop === prop);


// 时间戳转零时区
export const transferTime = (timeStamp) => {
  let timezone = 0 //目标时区：0
  let offset_GMT = new Date().getTimezoneOffset() // 本地时间和格林威治的时间差，单位为分钟
  let targetDate = new Date(timeStamp + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000)
  console.log("targetDate", dayjs(targetDate).format('YYYY-MM-DD hh:mm:ss'));
  return dayjs(targetDate).format('YYYY-MM-DD hh:mm:ss')
}



// 防抖函数
export const debounce = (handle, delay) => {
  let timer = null
  return function () {
    let _self = this,
      _args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      handle.apply(_self, _args)
    }, delay)
  }
}


/**
 * 清除空数据
 * @param {*} obj
 * @returns
 */
export const removePropertyOfNull = function (obj) {
  Object.keys(obj).forEach((item) => {
    if (obj[item] === 0) { }
    else if (!obj[item] || obj[item] == '') delete obj[item]
  })
  return obj
}


export const downloadFile = (url, fileName?, type?) => {
  // console.log(fileName)
  // 获取heads中的filename文件名
  let downloadElement = document.createElement('a')

  // 创建下载的链接
  downloadElement.href = url
  // 下载后文件名
  downloadElement.download = fileName || ''
  downloadElement.target = type || '_blank'
  document.body.appendChild(downloadElement)
  // 点击下载
  downloadElement.click()
  // 下载完成移除元素
  document.body.removeChild(downloadElement)
  // 释放掉blob对象
  // window.URL.revokeObjectURL(href)
}

/**
 * 文件下载方法
 * @param {*} file 文件数据
 * @param {*} fileName 文件名称
 * @param {*} fileType 文件类型
 */
export const fileDownload = (file, fileName, fileType) => {
  download(file, fileName, fileType)
}

// 滚动定位到form表单首个校验失败的位置
export const scrollIntoView = (className = "is-error", block: any = "center") => {
  Promise.resolve().then(() => {
    const target = document.getElementsByClassName(className);
    if (target.length) {
      target[0].scrollIntoView({
        behavior: "smooth", // 平滑过渡 值有auto、instant,smooth，缓动动画（当前是慢速的）
        block: block, // 上边框与视窗顶部平齐。默认值 值有start,center,end，nearest，当前显示在视图区域中间
      })
    }
  });
};

// 获取url参数
export const getUrlParams = (route) => {
  const { query } = route
  return query || {}
}

/**
 *  将以逗号分割字符串id转换成对应字段以逗号分割,人能看懂的文字
 * @param str 以逗号分割的字符串
 * @param list 遍历数组数据
 * @param key  判断的键的名称
 * @param name  需要返回显示数组数据的键名称
 * @returns 
 */
export const formateStr = (str: string, list: Array<[]>, key?: string , name?: string) => {
  if (str) {
    let arr = str.split(',')
    let res = []
    arr.forEach(item => {
      list.forEach(listItem => {
        if (listItem[key || 'id'] == item) {
          res.push(listItem[name || 'name'])
        }
      })
    })
    return res.join()
  }
  return ''
}

/** 将url的query参数转化为对象形式 */
export const parseQueryString = (url) => {
  const searchParams = new URLSearchParams(url.split('?')[1]);
  const obj = {};
  for (let [key, value] of searchParams.entries()) {
    obj[key] = value;
  }
  return obj;
}

/** 找到传入数组对应的label */
export const findLabel = (dataList, value) => {
  let label = ''
  dataList.forEach(item => {
    if(item.value === value){
      label = item.label
    }
  })
  return label
}


interface ITreeIterator {
  label: string;
  children: any[]
}
/** 合并树形结构,将label相同的节点合并 */
export const  treeIterator = (tree: ITreeIterator[]) => {
  const arr: ITreeIterator[] = []
  if (!Array.isArray(tree) || !tree.length) return arr
  tree.forEach((e: ITreeIterator) => {
    const index = arr.findIndex(i => i.label == e.label)
    if (index > -1) {
      arr[index].children = treeIterator([...arr[index].children, ...e.children])
    } else {
      arr.push({ ...e, children: treeIterator(e.children) })
    }
  });

  return arr;
}


// 判断两个数组是否有交集
export const intersect = (arr1=[], arr2=[]) => {
  return arr1?.some(item => arr2.includes(item))
}

